import React from 'react';

import { Heading, VStack, Stack } from '@chakra-ui/react';
import Image from 'next/image';

import Mail from '@assets/mail.svg';
// import officeicon from '@assets/officeicon.svg';
// import Phone from '@assets/phone.svg';
import { CustomText } from '@components/Custom-text';

const ContactCard = () => (
    <Stack padding={6} justifyContent="space-around" flexDir={{ base: 'column', md: 'row' }}>
        <VStack>
            <Image src={Mail} alt=" mail icon" />
            <Heading color="primary.dark" size="xl">
                Email
            </Heading>
            <CustomText color="shadowSlate" size="lg">
                Our friendly team is here to help.
            </CustomText>
            <Heading color="primary.dark" size="l">
                support@youryoda.zohodesk.in{' '}
            </Heading>
        </VStack>

        {/* <VStack mt="2">
            <Image src={officeicon} style={{ width: '38px' }} alt="office icon" />
            <Heading color="primary.dark" size="xl">
                {' '}
                Office
            </Heading>
            <CustomText color="shadowSlate" size="lg">
                Our friendly team is here to help.
            </CustomText>
            <Heading color="primary.dark" size="l" textAlign="center">
                2118 Thornridge Cir. Syracuse, Connecticut 35624{' '}
            </Heading>
            <Heading color="primary.dark" size="l">
                Connecticut 35624{' '}
            </Heading>
        </VStack> */}

        {/* <VStack>
            <Image src={Phone} alt="phone icon" />

            <Heading color="primary.dark" size="xl">
                {' '}
                Phone.
            </Heading>
            <CustomText color="#4B5563" size="lg">
                Our friendly team is here to help.
            </CustomText>
            <Heading color="primary.dark" size="l">
                (480) 555-0103
            </Heading>
        </VStack> */}
    </Stack>
);

export default ContactCard;
